/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/prop-types */
/* eslint-disable no-console */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-nested-ternary */

import React, { useMemo } from 'react';
import { Drawer, Form, Input, Row, Col, Divider, Button, Space, Badge } from 'antd';
import dayjs from 'dayjs';
import CustomAvatar from '../Global/CustomAvatar/CustomAvatar';
import ImageComponent from '../Global/ImageComponent/ImageComponent';

const RiderDetailsDrawer = ({ open, onClose, rider, onApprove, onDeny }) => {

	// Format rider name
	const riderDisplayName = useMemo(() => {
		if (!rider) return '';
		return `${rider.name} ${rider.surname}`;
	}, [rider]);

	// Phone formatting
	const formattedPhone = useMemo(() => {
		if (!rider) return 'N/A';
		return rider.phoneCountryCode
			? `+${rider.phoneCountryCode} ${rider.phone}`
			: rider.phone || 'N/A';
	}, [rider]);

	// Registration date
	const formattedRegistrationDate = useMemo(() => {
		if (!rider?.created) return 'N/A';
		return dayjs(rider.created).format('DD/MM/YYYY');
	}, [rider?.created]);

	const handleApprove = () => {
		if (onClose) onClose();
		if (onApprove && rider) onApprove(rider);
	};

	const handleDeny = () => {
		if (onClose) onClose();
		if (onDeny && rider) onDeny(rider);
	};

	if (!rider) return null;

	return (
		<Drawer
			title="Rider Application Details"
			width={700}
			onClose={onClose}
			open={open}
			footer={
				<div style={{ textAlign: 'right' }}>
					<Space>
						<Button onClick={onClose}>Close</Button>
						<Button
							type="primary"
							style={{ backgroundColor: '#52c41a' }}
							onClick={handleApprove}
						>
							Approve
						</Button>
						<Button danger type="primary" onClick={handleDeny}>
							Deny
						</Button>
					</Space>
				</div>
			}
		>
			<Form layout="vertical" disabled>
				{/* Profile Picture */}
				<Form.Item label="Profile Picture">
					<div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
						{rider.profilePicture ? (
							<ImageComponent size={80} imageId={rider.profilePicture} />
						) : (
							<CustomAvatar name={riderDisplayName} type="initials" size={80} />
						)}
						<div>
							<h3 style={{ margin: 0 }}>{riderDisplayName}</h3>
							<Badge status="processing" text="PENDING APPROVAL" />
						</div>
					</div>
				</Form.Item>

				<Divider>Personal Information</Divider>

				<Row gutter={16}>
					<Col span={12}>
						<Form.Item label="First Name">
							<Input value={rider.name} />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item label="Last Name">
							<Input value={rider.surname} />
						</Form.Item>
					</Col>
				</Row>

				<Row gutter={16}>
					<Col span={12}>
						<Form.Item label="Email">
							<Input value={rider.email} />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item label="Phone">
							<Input value={formattedPhone} />
						</Form.Item>
					</Col>
				</Row>

				<Row gutter={16}>
					<Col span={12}>
						<Form.Item label="Gender">
							<Input value={rider.gender || 'N/A'} />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item label="Registration Date">
							<Input value={formattedRegistrationDate} />
						</Form.Item>
					</Col>
				</Row>

				<Row gutter={16}>
					<Col span={6}>
						<Form.Item label="Country">
							<Input value={rider.country || 'N/A'} />
						</Form.Item>
					</Col>
					<Col span={18}>
						<Form.Item label="Address">
							<Input value={rider.address || 'N/A'} />
						</Form.Item>
					</Col>
				</Row>

				{/* Corporate Information */}
				{rider.corporate && (
					<>
						<Divider>Corporate Information</Divider>
						<Form.Item label="Corporate">
							<Input value={rider.corporate.name} />
						</Form.Item>
					</>
				)}
			</Form>
		</Drawer>
	);
};

export default RiderDetailsDrawer;
